var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-body", staticStyle: { "background-color": "#fff" } },
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-tabs",
            { attrs: { card: "" } },
            [
              _c(
                "b-tab",
                { attrs: { title: "1:1 문의", active: "" } },
                [
                  _c("b-card-text", [
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-striped table-bordered table-hover"
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v("분류")]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v("제목")]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v("상태")]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v("등록일")]
                            )
                          ])
                        ]),
                        _c(
                          "tbody",
                          [
                            _c(
                              "tr",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.userBoardList.length == 0,
                                    expression: "userBoardList.length==0"
                                  }
                                ],
                                staticClass: "text-center"
                              },
                              [
                                _c("td", { attrs: { colspan: "4" } }, [
                                  _vm._v("No matching records")
                                ])
                              ]
                            ),
                            _vm._l(_vm.userBoardList, function(item, index) {
                              return _c(
                                "tr",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.userBoardList.length != 0,
                                      expression: "userBoardList.length!=0"
                                    }
                                  ],
                                  key: index
                                },
                                [
                                  _c(
                                    "td",
                                    { staticClass: "align-middle text-center" },
                                    [_vm._v(_vm._s(item.boardCatName))]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "align-middle text-center" },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "align-middle text-center" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.answer
                                            ? "답변 완료"
                                            : "답변 미완료"
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "align-middle text-center" },
                                    [_vm._v(_vm._s(item.regDt))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: "구매 내역" } },
                [_c("b-card-text", [_vm._v("준비 중 입니다.")])],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }